import { lazy } from "react";
export const ConnectedPatientLobbyLazy = lazy(() =>
  import("./ConnectedPatientLobby")
);
